import React, { useEffect, useState } from 'react'
import { DetallesCapis, getOrDeleteRequest } from "../utils/utils";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleUser, faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import Cookies from 'js-cookie';

import DataTableComponent from './DataTableComponent/DataTableComponent';

function CRUDCapis() {
	const [loading, setLoading] = useState(true);
	const [capis, setCapis] = useState({ data: [] });
	const [search, setSearch] = useState("");
	const [selectedNaturaleza, setSelectedNaturaleza] = useState("");

	const columns = [
		// {
		// 	name: '#',
		// 	width: '50px',
		// 	selector: (row) => row.id
		// },
		{
            name: '# de Autorización',
            width: '180px',
            selector: (row) => row.id_autorizacion
        },
        {
            name: 'CAPI',
            width: '300px',
            selector: (row) => row.nombre_establecimiento
        },
        {
            name: 'Departamento',
            width: '170px',
            selector: (row) => row.departamento ? row.departamento : 'No especificado'
        },
        {
            name: 'Municipio',
            width: '250px',
            selector: (row) => row.municipio ? row.municipio : 'No especificado'
        },
        {
            name: 'Distrito',
            width: '220px',
            selector: (row) => row.distrito ? row.distrito : 'No especificado'
        },
        {
            name: 'Privacidad',
            width: '120px',
            selector: (row) => row.naturaleza
        },
		// {
        //     name: 'Estado',
        //     width: '110px',
        //     selector: (row) => {
		// 		return row.status === 1 ? 
		// 			<span className="bg-green-100 text-green-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded-full dark:bg-green-200 dark:text-green-900">
		// 				Activo
		// 			</span>
		// 		: 
		// 			<span className="bg-red-100 text-red-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded-full dark:bg-red-200 dark:text-red-900">
		// 				Inactivo
		// 			</span>
		// 		;
		// 	}
        // },
    ];

	async function getCapisList(page = 1, items = 10, search = null) {
		setLoading(true);

        let uri = search ? `capis?page=${page}&items=${items}&search=${search}` : `capis?page=${page}&items=${items}`;
        let response = await getOrDeleteRequest(
            uri,
            'GET',
        );
		
        if (response.type === 'success') {
            setCapis(response.data);
        } else {
            setCapis([]);
        }
        setLoading(false);
	}

	useEffect(function () {
		if (!loading) return;
		getCapisList();
	}, []);

	const eliminarCapi = async (id_autorizacion) => {

		let session = Cookies.get("AuthToken");
		let uri = process.env.REACT_APP_API_URL + `admin/capis/${id_autorizacion}`;

		let config = {
			headers: {
				'Content-Type': 'multipart/form-data',
				'Authorization': `Bearer ${session}`,
			}
		};

		// console.log(id_autorizacion, 'e')

		Swal.fire({
			title: "¿Estás seguro de borrar este CAPI?",
			text: "¡Esta acción no se puede deshacer!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#d33",
			cancelButtonColor: "#3085d6",
			confirmButtonText: "Sí, eliminar",
			cancelButtonText: "Cancelar",
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					await axios.delete(uri, config);
					setCapis((prevCapis) => prevCapis.filter((capi) => capi.id_autorizacion !== id_autorizacion));
					Swal.fire("¡Eliminado!", "El CAPI ha sido eliminado.", "success");
				} catch (error) {
					console.error("Error al eliminar CAPI", error);
					Swal.fire("Error", "No se pudo eliminar el CAPI.", "error");
				}
			}
		});
	};

	const searcher = (e) => {
		setSearch(e.target.value);
	}

	const naturalezaCapi = (e) => {
		console.log("Seleccionaste:", e.target.value)
		setSelectedNaturaleza(e.target.value);
	}

	let results = (capis.data ?? []).filter((dato) =>
		(selectedNaturaleza === "" || dato.naturaleza.trim().toLowerCase() === selectedNaturaleza.toLowerCase()) &&
		(search === "" || dato.nombre_establecimiento.toLowerCase().includes(search.toLowerCase()))
	);
	// console.log(results);
	return (
		<>
			<div className="w-auto h-full py-10 px-3">
				<div className='flex flex-col justify-center w-auto h-auto items-center text-lg'>
					<div className="flex flex-col justify-center w-full mb-5">
						<div className="flex flex-row w-full justify-start items-start p-4">
							<Link to="/Mantenimiento" className="flex justify-start">
								<button className="bg-white border-4 border-[#0E7FA0] font-medium drop-shadow-2xl shadow-2xl text-white w-full rounded-full w-[50px] h-[50px] p-[12px]"><FontAwesomeIcon icon={faArrowLeft} className='text-[#0E7FA0] text-lg' /></button>
							</Link>
							<div className="flex flex-col w-full px-3 justify-between">
								<h1 className="text-4xl font-bold text-[#0E7FA0] text-start mb-2">CAPIS</h1>
								<p className="text-base">Está diseñada para la edición de un CAPI. Aquí podrás modificar y actualizar la información existente de manera rápida y sencilla.</p>
							</div>
						</div>
					</div>
				</div>
				<div className='h-full w-auto mx-6'>
					<DataTableComponent
						nameTable={"CAPIS"}
						data={capis}	
						columns={columns}
						loading={loading}
						setLoading={setLoading}
						reload={getCapisList}
						toEdit={'/EditarCapi/'}
						toDelete={'admin/capis/'}
					/>
				</div>
			</div>
		</>
	)
}

export default CRUDCapis;